import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { RootState } from "../store"
import BaseApi from "../../api/api"
import { NotificationService } from "../../features/NotificationService/NotificationService"
import { STATUS } from "../../utils/const"

export type FeedShopType = {
  lastPricesUpdated?: string
  lastStocksUpdated?: string
  errors?: { type: string; errors: string[] }[]
  status?: STATUS
  isExistRecode?: boolean
  calcIdent?: string
  authFieldIdent?: string
}

type initialStateType = {
  [key: string]: FeedShopType
}

const initialState: initialStateType = {}

const feedShopsSlice = createSlice({
  name: "feedShops",
  initialState,
  reducers: {
    setFeedShopsState: (state, action: PayloadAction<initialStateType>) => {
      Object.keys(action.payload).forEach((key) => {
        state[key] = action.payload[key]
      })
    },
    setFeedShopCalcIdent: (
      state,
      action: PayloadAction<{ shop: string; calcIdent: string }>,
    ) => {
      const { shop, calcIdent } = action.payload
      if (state[shop]) {
        state[shop].calcIdent = calcIdent
      } else {
        state[shop] = { calcIdent }
      }
    },
  },
})

export const selectFeedShopsStore = (state: RootState) => state.feedShopsState

export default feedShopsSlice.reducer

export const { setFeedShopsState, setFeedShopCalcIdent } =
  feedShopsSlice.actions

export const updateFeedShopsState = createAsyncThunk(
  "updateFeedShopsState",
  (_, { dispatch }) => {
    return BaseApi.feedShopsState()
      .then((response) => {
        if (response.data) {
          dispatch(setFeedShopsState(response.data))
        }
      })
      .catch((error) => {
        console.error(error)
      })
  },
)

export const feedShopWbUpdateStocks = createAsyncThunk(
  "feedShopWbUpdateStocks",
  (props: {
    shopIdent: string
    selectedStorageId: string
    updatePrices: boolean
    updateStocks: boolean
    isReturnToPromo?: boolean
    customArgs?: { [key: string]: boolean }
  }) => {
    const {
      shopIdent,
      selectedStorageId,
      updatePrices,
      updateStocks,
      isReturnToPromo,
      customArgs,
    } = props
    return BaseApi.updateWbStocks(
      shopIdent,
      selectedStorageId,
      updatePrices,
      updateStocks,
      isReturnToPromo,
      customArgs,
    )
      .then((response) => {
        if (response.data) {
          NotificationService.showNotification({
            message: response.data.message,
            level: (response.data.success && "success") || "error",
          })
        }
      })
      .catch((error) => {
        console.error("feedShopWbUpdateStocks error:", error)
        NotificationService.showNotification({
          message:
            error?.response?.data?.message || "Ошибка при обновлении остатков",
          level: "error",
        })
      })
  },
)

export const deleteFeedShopWbRecode = createAsyncThunk(
  "deleteFeedShopWbRecode",
  (shopIdent: string) => {
    return BaseApi.deleteWbRecode(shopIdent)
      .then((response) => {
        NotificationService.showNotification({
          message: response.data.message,
          level: (response.data.success && "success") || "error",
        })
      })
      .catch((error) => {
        console.error("deleteFeedShopWbRecode error:", error)
        NotificationService.showNotification({
          message:
            error?.response?.data?.message ||
            "Ошибка при удалении перекодировки",
          level: "error",
        })
      })
  },
)

export const uploadFeedShopWbRecode = createAsyncThunk(
  "uploadFeedShopWbRecode",
  async ({ shopIdent, rows }: { shopIdent: string; rows: any[] }) => {
    return BaseApi.uploadWbRecode(shopIdent, rows)
      .then((response) => {
        NotificationService.showNotification({
          message: response.data.message,
          level: (response.data.success && "success") || "error",
        })
      })
      .catch((error) => {
        console.error("uploadFeedShopWbRecode error:", error)
        NotificationService.showNotification({
          message:
            error?.response?.data?.message ||
            "Ошибка при загрузке перекодировки",
          level: "error",
        })
      })
  },
)
